var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDeletedFile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 24 24.06"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.1.06v6h6l-6-6zM21.1 21.06v-1.25L3.3 2.01c-.12.33-.2.68-.2 1.05v18c0 1.65 1.35 3 3 3h12c1.65 0 3-1.35 3-3Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.1 16.96v-9.4h-6c-.83 0-1.5-.67-1.5-1.5v-6H6.1c-.55 0-1.05.16-1.49.41L21.1 16.96Z"
}))), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m1 1 22 22",
  style: {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }
}));
export default SvgDeletedFile;